/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { superadminlogin } from "../../../redux/actions/auth"; // Import the superadminlogin action
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { Spinner } from "react-bootstrap";

const SuperAdminLogin = () => {
  const routes = all_routes;
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  type AppDispatch = ThunkDispatch<{}, {}, AnyAction>;
  const _form = {
    username: "",
    password: "",
  };
  const dispatch: AppDispatch = useDispatch();

  const [form, setForm] = useState(_form);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    setLoading(true);
    e.preventDefault();

    // Define success and error callback functions for the login action creator
    const onSuccess = (data: any) => {
      setLoading(false);
      toast.success("Login successfully!");
      const user = data.user;

      // Redirect based on role
      if (user.role?.toLowerCase() === "superadmin") {
        window.location.href = routes.superAdminDashboard;
      } else {
        toast.warning("You do not have permission to access this page.");
      }
    };

    const onError = (err: any) => {
      console.error("Login error:", err);
      setLoading(false);

      // Check if the error is related to incorrect username/password
      if (err && err.response?.status === 401) {
        toast.warning("Password or username is not correct");
      } else {
        toast.warning(
          "An error occurred. Please check Device Connectivity and try again."
        );
      }
    };

    // Dispatch the superadminlogin action with form data and the success/error callbacks
    dispatch(
      superadminlogin(
        {
          username: form.username,
          password: form.password,
          history: navigate,
        },
        onSuccess,
        onError
      )
    );
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  useEffect(() => {
    localStorage.setItem("menuOpened", "Dashboard");
  }, []);

  const handleChange = (e: any) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  return (
    <div className="container-fuild">
      <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
              <div className="col-md-4 mx-auto p-4">
                <form onSubmit={handleSubmit}>
                  <div>
                    <div className="card">
                      <div className="card-body pb-3">
                        <div className="row text-center">
                          <a href="#">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <img
                                src="../assets/img/startupIcon.png"
                                style={{
                                  width: 220,
                                  height: 200,
                                }}
                                alt="Elite Logo"
                              />
                            </div>
                          </a>
                        </div>
                        <div className="login-or">
                          <span className="span-or">Super Admin SignIn</span>
                        </div>
                        <div className="mb-3 ">
                          <label className="form-label">Username:</label>
                          <div className="input-icon mb-3 position-relative">
                            <span className="input-icon-addon">
                              <i className="ti ti-mail" />
                            </span>
                            <input
                              type="text"
                              defaultValue=""
                              className="form-control"
                              name="username"
                              value={form.username}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <label className="form-label">Password</label>
                          <div className="pass-group">
                            <input
                              type={isPasswordVisible ? "text" : "password"}
                              className="pass-input form-control"
                              name="password"
                              value={form.password}
                              onChange={handleChange}
                              required
                            />
                            <span
                              className={`ti toggle-password ${
                                isPasswordVisible ? "ti-eye" : "ti-eye-off"
                              }`}
                              onClick={togglePasswordVisibility}
                            />
                          </div>
                        </div>
                        <div className="form-wrap form-wrap-checkbox">
                          <div className="d-flex align-items-center">
                            <div className="form-check form-check-md mb-0">
                              <input
                                className="form-check-input mt-0"
                                type="checkbox"
                              />
                            </div>
                            <p className="ms-1 mb-0 ">Remember Me</p>
                          </div>
                          <div className="text-end ">
                            <Link
                              to={routes.forgotPassword}
                              className="link-danger"
                            >
                              Forgot Password?
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="p-4 pt-0">
                        <div className="mb-3">
                          <button
                            type="submit"
                            className="btn btn-primary w-100"
                            disabled={loading}
                          >
                            {loading ? <Spinner /> : "Sign In"}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 text-center">
                      <p
                        className="mb-0 "
                        style={{ fontSize: "25px", color: "black" }}
                      >
                        Powered by{" "}
                        <a
                          href="https://elscholar.ng/"
                          target="_blank"
                          style={{ color: "blue" }}
                        >
                          Elite Edu Tech
                        </a>
                      </p>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;